// extracted by mini-css-extract-plugin
export default {"wrapper":"ckeck_wrapper__17AiX","title":"ckeck_title__wp6-D","value":"ckeck_value__ilm9E","checkboxWrapper":"ckeck_checkboxWrapper__FL4qQ"};